export default __webpack_public_path__ + "static/media/ecosystem.38de0d2a.png";